import App from "theme/base/App"

import shop from "shop/shop"
import "./theme.scss"

shop.config.variantNames = ["Variante"]

export default App



// WEBPACK FOOTER //
// ./src/theme/sandra/App.js